<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section *ngIf="filteredCities">
      <div class="card">
        <div class="card-header">
          <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
            <label class="d-flex align-items-center mb-0">
              <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="doFilter()" />
            </label>
          </div>
          <div>
            <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.md]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'">
              <label class="d-flex align-items-center mb-0">
                {{ "SHOW" | translate }}
                <select class="form-control ml-075 pr-3" [(ngModel)]="tableLimit">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <a *ngIf="_authenticationService.hasCapability('city_add')" [routerLink]="'/dashboard/cities/add'" class="btn btn-outline-primary">{{ "ADD" | translate }}</a>
          </div>
        </div>
        <div class="card-body px-0 pb-0">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="50"
            [scrollbarH]="true"
            [rowHeight]="60"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filteredCities"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate), totalMessage: ('TOTAL' | translate).toLowerCase() }"
          >
            <ngx-datatable-column name="{{ 'NAME' | translate }}" prop="name" [sortable]="true" width="250">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.name }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="{{ 'INITIALS' | translate }}" prop="initials" [sortable]="true" width="70">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.initials }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="{{ 'PROVINCE' | translate }}" prop="province" [sortable]="true" width="100">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.province }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="{{ 'REGION' | translate }}" prop="region" [sortable]="true" width="100">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.region }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="{{ 'CAPITAL_CITY' | translate }}" prop="is_main" [sortable]="true" width="200">
              <ng-template ngx-datatable-cell-template let-row="row">{{ (row.is_main ? "YES" : "NO") | translate }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" prop="roles" [sortable]="false" width="90">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex">
                  <a [routerLink]="'/dashboard/cities/edit/' + row.id" *ngIf="_authenticationService.hasCapability('city_edit')">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </a>
                  <button (click)="remove($event, row.id)" *ngIf="_authenticationService.hasCapability('city_delete')" class="ml-1 border-0 text-secondary pr-1 bg-transparent">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
